let callbacks: Array< () => void > = [];
let isComplete = false;
let timeoutId: number | null = null;

function runCallbacks(): void {
	clearTimeout();
	document.removeEventListener( 'readystatechange', onReadyStateChange );

	callbacks.forEach( ( callback ) => callback() );
	callbacks = [];
}

function clearTimeout(): void {
	if ( timeoutId !== null ) {
		window.clearTimeout( timeoutId );
		timeoutId = null;
	}
}

function onReadyStateChange(): void {
	if ( isComplete ) {
		return;
	}

	if ( document.readyState === 'complete' ) {
		isComplete = true;
		runCallbacks();
	} else if ( document.readyState === 'interactive' && ! timeoutId ) {
		isComplete = true;
		timeoutId = window.setTimeout( runCallbacks, 5000 );
	}
}

onReadyStateChange();

document.addEventListener( 'readystatechange', onReadyStateChange );

export function documentReady( callback: () => void ): void {
	if ( isComplete ) {
		callback();
	} else {
		callbacks.push( callback );
	}
}
